export const ONE_DAY_TIMESTAMP = 24 * 3600 * 1000;
